import {DataListModel} from '../interface';
import {PartnerModel} from './partner.model';

export class PartnerItemsModel extends DataListModel {
  items: PartnerModel[] = [];
}
